export const changeAvailability21RequestOptions = [
  'Inoperative',
  'Operative',
] as const;
export type ChangeAvailability21RequestOption =
  (typeof changeAvailability21RequestOptions)[number];
